import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ConfigurationService } from 'mbs-ui-shared';
import { Observable } from 'rxjs';
import { SnmpAlertDeviceTypes, SnmpAlertTypes } from '../store/alert/model';

@Injectable()
export class SnmpService {
  private mbsStageKey: string;
  private params: any;
  private snmpDeviceTypesApi: string;

  constructor(@Inject(ConfigurationService) private config: ConfigurationService, private http: HttpClient) {
    const rmmBaseUrl = this.config.get('rmmBaseHref');
    this.mbsStageKey = this.config.get('mbsStageKey');
    this.snmpDeviceTypesApi = `${rmmBaseUrl}/api/SnmpDeviceTypes`;
    this.params = this.mbsStageKey
      ? {
          mbsStageKey: this.mbsStageKey
        }
      : null;
  }

  getDeviceTypes(): Observable<SnmpAlertDeviceTypes[]> {
    return this.http.get<SnmpAlertDeviceTypes[]>(this.snmpDeviceTypesApi, { params: this.params });
  }

  getDeviceAlerts(): Observable<SnmpAlertTypes[]> {
    return this.http.get<SnmpAlertTypes[]>(this.snmpDeviceTypesApi + `/alerts`, { params: this.params });
  }

  getDeviceCustomAlerts(): Observable<SnmpAlertTypes[]> {
    return this.http.get<SnmpAlertTypes[]>(this.snmpDeviceTypesApi + `/customalerts`, { params: this.params });
  }

  getDeviceCustomProperties(snmpDeviceTypeGuid: number) {
    return this.http.get(this.snmpDeviceTypesApi + `/${snmpDeviceTypeGuid}/customproperties`, { params: this.params });
  }

  getDeviceCustomPropertyById(snmpDeviceTypeGuid: number, customPropertyGuid: string) {
    return this.http.get(this.snmpDeviceTypesApi + `/${snmpDeviceTypeGuid}/customproperties/${customPropertyGuid}`, {
      params: this.params
    });
  }

  deleteDeviceCustomProperties(deviceType: number, snmpDeviceTypeGuid: string) {
    return this.http.delete(this.snmpDeviceTypesApi + `/${deviceType}/customproperties/${snmpDeviceTypeGuid}`, { params: this.params });
  }

  saveDeviceCustomProperties(snmpDeviceTypeGuid: number, body) {
    return this.http.post(this.snmpDeviceTypesApi + `/${snmpDeviceTypeGuid}/customproperties/register`, body, { params: this.params });
  }

  updateDeviceCustomProperties(deviceType: number, snmpDeviceTypeGuid: string, body) {
    return this.http.put(this.snmpDeviceTypesApi + `/${deviceType}/customproperties/${snmpDeviceTypeGuid}`, body, { params: this.params });
  }

}
